import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Grid, MenuItem, Paper, Select, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

export const FilterBy = ({
    fonts,
    onSearch,
    onClearFilters,
}) => {
    const [titleValue, setTitleValue] = useState('');
    const [authorValue, setAuthorValue] = useState('');
    const [selectedTypeIndex, setSelectedTypeIndex] = useState('');

    const applySearch = () => {
        const selectedFont = selectedTypeIndex === '' ? null : fonts[selectedTypeIndex];
        onSearch(titleValue, authorValue, selectedFont ? selectedFont.name : null, selectedFont ? selectedFont.id : null);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') applySearch();
    };

    const handleCleanFilters = () => {
        setTitleValue('');
        setAuthorValue('');
        setSelectedTypeIndex('');
        onClearFilters();
    };

    return (
        <Grid item xs={12} lg={4}>
            <Paper sx={{ p: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                    <FilterListIcon />
                    <Typography variant="h6">Filtros</Typography>
                </Stack>

                <Typography variant="body2" mb={1}>Buscar</Typography>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Título ou código..."
                    value={titleValue}
                    onChange={(e) => setTitleValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={{ mb: 2 }}
                />

                <Typography variant="body2" mb={1}>Autor / Compositor</Typography>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Nome do autor ou compositor..."
                    value={authorValue}
                    onChange={(e) => setAuthorValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={{ mb: 2 }}
                />

                <Typography variant="body2" mb={1}>Tipo de Ficha</Typography>
                <Select
                    fullWidth
                    size="small"
                    value={selectedTypeIndex}
                    displayEmpty
                    onChange={(e) => setSelectedTypeIndex(e.target.value)}
                    sx={{ mb: 2 }}
                >
                    <MenuItem value="">Todos os tipos</MenuItem>
                    {fonts.map((font, index) => (
                        <MenuItem key={index} value={index}>{font.name}</MenuItem>
                    ))}
                </Select>

                <Stack direction="row" spacing={1}>
                    <Button
                        variant="contained"
                        startIcon={<SearchIcon />}
                        onClick={applySearch}
                        sx={{ flex: 2, backgroundColor: '#7BAAA7', '&:hover': { backgroundColor: '#6A9391' }, color: '#ffffff' }}
                    >
                        Pesquisar
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleCleanFilters}
                        sx={{ flex: 1, borderColor: '#7BAAA7', color: '#7BAAA7', '&:hover': { borderColor: '#6A9391', color: '#6A9391' } }}
                    >
                        Limpar
                    </Button>
                </Stack>
            </Paper>
        </Grid>
    );
};
